import { appStorageService } from '@saucelabs/sl-util-axios';
import axios from 'axios';

export const uploadMobileApp = (
  app,
  onUploadProgress,
  cancelTokenHandler = () => null,
) => {
  const appFormData = new FormData();
  const config = {
    onUploadProgress,
    cancelToken: new axios.CancelToken(cancelTokenHandler),
  };

  appFormData.append('payload', app);
  appFormData.append('name', app.name);

  return appStorageService.post(
    '/v1/storage/upload',
    appFormData,
    config,
  );
};
